import type { GetSigninResponse } from './types';

import { getGenericEndpoint } from './get.api';

export const getSignin = async (lang?: string) => {
    return await getGenericEndpoint<GetSigninResponse>('signin', lang);
};
